import "./Disclaimers.css";
import React from "react";
import { observer } from "mobx-react";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import Propulator from "higher-order/Propulator";
import ContentItem from "shared/components/cms/ContentItem";

@observer
class Disclaimers extends React.Component {

    render() {
        const {
            disclaimers
        } = this.props;

        if (isEmpty(disclaimers)) {
            return null;
        }

        return (
            <div className="legal">
                <div className="footnotes">
                    {map(disclaimers, d => (
                        <div key={d.symbol} className="footnote">
                            {d.symbol}{". "}
                            <ContentItem contentKey={d.contentKey} sharedKey={d.sharedKey} tag="span" stringFormatArgs={d.messageArgs} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default Propulator(Disclaimers);
